import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { hideScroll } from 'src/theme/css';
import { useAuthContext } from 'src/auth/hooks';

// import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';

import { NAV } from '../config-layout';
import { usePermissionWGNavData } from './config-permission-wgs-navigation';
// import NavToggleButton from '../common/nav-toggle-button';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = useAuthContext();
  const workGroupsNavData = usePermissionWGNavData();

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      {/* <NavToggleButton
        sx={{
          top: 22,
          right: NAV.W_MINI - 12,
        }}
      /> */}

      <Stack
        sx={{
          pb: 5,
          height: 1,
          position: 'fixed',
          right: 0,
          top: 170,
          width: NAV.W_MINI,
          borderLeft: (theme) => `dashed 1px ${theme.palette.divider}`,
          // borderTop: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        {/* <Logo sx={{ mx: 'auto', my: 2 }} /> */}

        <NavSectionMini
          data={workGroupsNavData}
          slotProps={{
            currentRole: user?.role,
          }}
        />
      </Stack>
    </Box>
  );
}
